import { StyleSheet } from 'aphrodite';
import { children, media, palette } from 'util/style-helpers';

export const style = () => {
  return StyleSheet.create({
    main: {
      flexGrow: 1,
      padding: '30px 15px',
    },
    categorySection: {
      color: palette.red,
      ':not(:last-child)': {
        marginBottom: '12px',
        [media.tablet]: {
          marginBottom: '35px',
        },
        [media.desktop]: {
          marginBottom: '125px',
        },
      },
      [children('h1')]: {
        margin: '0 auto 30px 0',
        textAlign: 'center',
        fontSize: '25px',
        lineHeight: '35px',

        [media.tablet]: {
          margin: '0 auto 50px 0',
          fontSize: '40px',
          lineHeight: '50px',
        },
        [media.desktop]: {
          ':first-child': {
            marginTop: '35px',
          },
        },
      },
    },
    videoGrid: {
      margin: '0 auto',

      [media.desktop]: {
        maxWidth: 875,
      },
    },
    videoTileContainer: {
      margin: '0 -15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 980,

      [children('> div')]: {
        marginBottom: 30,
      },

      [media.desktop]: {
        justifyContent: 'flex-start',
        [children('> div')]: {
          marginBottom: 25,
        },
      },
    },
    carousel: {
      margin: '10px auto 0 auto',
      [media.desktop]: {
        marginTop: '45px',
      },
    },
  });
};
